import type { CreateLeadInput, Lead, LeadStatus } from '@bcl/shared';
import { api } from '@/lib/api';

export async function createLead(input: CreateLeadInput): Promise<Lead> {
  const { data } = await api.post<Lead>('/leads', input);
  return data;
}

export async function listMyLeads(): Promise<Lead[]> {
  const { data } = await api.get<Lead[]>('/leads/mine');
  return data;
}

export async function listAllLeads(status?: LeadStatus): Promise<Lead[]> {
  const { data } = await api.get<Lead[]>('/leads', {
    params: status ? { status } : undefined,
  });
  return data;
}

export async function takeLead(leadId: string): Promise<Lead> {
  const { data } = await api.post<Lead>(`/leads/${leadId}/take`);
  return data;
}

export async function convertLead(
  leadId: string,
): Promise<{ lead: Lead; projectId: string }> {
  const { data } = await api.post<{ lead: Lead; projectId: string }>(
    `/leads/${leadId}/convert`,
  );
  return data;
}

export async function rejectLead(leadId: string, reason: string): Promise<Lead> {
  const { data } = await api.post<Lead>(`/leads/${leadId}/reject`, { reason });
  return data;
}
